import invariant from 'fbjs/lib/invariant'
export default invariant



/** WEBPACK FOOTER **
 ** ./app/utils/invariant.js
 **/